module.exports = __webpack_public_path__ + "static/betalogo-acf53ef8c0875ac879fe9d1b7fb66aef.svg";